module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./axios/index.js
// module id = 28
// module chunks = 23